import type { ComponentChildren } from "preact"

import type { ButtonSize, ButtonVariant, TooltipSide } from "#public"

import { TooltipIconButton } from "./TooltipIconButton"

// One end of a prev/next stepper: disabled at the matching bound, and clicking
// steps `value` by ±`step` through `on_value`, with a tooltip. Purely
// behavioral — it adds no styling of its own, so the caller owns the look
// (icon via children, plus className/size/variant). The same control backs
// both the header pager's small chevrons and the big over-book nav arrows;
// `disabled` fades via the Button's own `disabled:` classes (or a caller
// override like `disabled:opacity-0`).
export function StepButton({
  children,
  className,
  direction,
  max,
  min,
  on_value,
  side,
  size,
  step = 1,
  title,
  value,
  variant,
}: {
  children: ComponentChildren
  className?: string
  direction: "next" | "prev"
  max: number
  min: number
  on_value: (n: number) => void
  side?: TooltipSide
  size?: ButtonSize
  step?: number
  title: string
  value: number
  variant?: ButtonVariant
}) {
  const prev = direction === "prev"
  return (
    <TooltipIconButton
      className={className}
      disabled={prev ? value <= min : value >= max}
      onClick={() => on_value(value + (prev ? -step : step))}
      side={side}
      size={size}
      title={title}
      variant={variant}
    >
      {children}
    </TooltipIconButton>
  )
}
